import { colors } from 'baseui/tokens';
import { string2money } from 'common/utils/string';
import Text from 'components/elements/text';
import {
  FullContainer,
  SeparatorHorizontal,
  SeparatorVertical,
} from 'components/styles';
import { format } from 'date-fns';
import React from 'react';

import { ActivityContainer, ActivityContent } from '../../style';
import { ActivityPurchaseGuestsFormType } from '../form-type';

interface Props {
  data: ActivityPurchaseGuestsFormType[];
  isGrouped?: boolean;
}

export default function SummaryItem(props: Props) {
  const { data: _data, isGrouped } = props;

  const data = React.useMemo(() => {
    const temp: {
      name: string;
      items: {
        name: string;
        price: number;
        itemPrice: number;
        qty: number;
        date: Date;
        customId: string;
      }[];
    } = {
      items: [],
      name: '',
    };
    if (isGrouped) {
      temp.name = _data.map((val) => val.guestName).join(', ');
      temp.items = _data.reduce<
        {
          name: string;
          price: number;
          itemPrice: number;
          qty: number;
          customId: string;
          date: Date;
        }[]
      >((prev, curr) => {
        const val = curr.activityPurchaseGuestDetails.map((item) => {
          const name = `${item.activityName} | ${(
            item.type || ''
          ).toUpperCase()}`;

          return {
            customId: item.customId || '',
            name,
            price: item.totalPrice * _data.length,
            itemPrice: item.price,
            qty: item.qty * _data.length,
            date: item.date || new Date(),
          };
        });
        return val;
      }, []);
    } else {
      temp.name = _data[0].guestName || '';
      temp.items = _data[0].activityPurchaseGuestDetails.map((item) => ({
        name: `${item.activityName} | ${(item.type || '').toUpperCase()} | `,
        price: item.totalPrice,
        itemPrice: item.price,
        qty: item.qty,
        customId: item.customId || '',
        date: item.date || new Date(),
      }));
    }

    return temp;
  }, [_data, isGrouped]);

  return (
    <FullContainer>
      <>
        {isGrouped ? (
          _data.map((val, idx) => (
            <React.Fragment key={idx}>
              <Text variant="LabelSmall">{val.guestName}</Text>
              <SeparatorVertical $margin={8} />
            </React.Fragment>
          ))
        ) : (
          <>
            <Text variant="LabelSmall">{data.name}</Text>
            <SeparatorVertical $margin={8} />
          </>
        )}
        {data.items.map((item, idx) => (
          <ActivityContainer key={idx}>
            <ActivityContent>
              <Text variant="LabelSmall">
                (x{item.qty || 0}) {item.name.toUpperCase()}
              </Text>
              <SeparatorHorizontal $margin={2} />
              <Text variant="LabelSmall">
                {format(item.date as Date, 'dd/MM/yyyy')}
              </Text>
              <SeparatorHorizontal $margin={8} />
              <Text variant="LabelSmall" $style={{ color: colors.gray500 }}>
                {`@ Rp ${string2money(item.itemPrice || 0)}`}
              </Text>
            </ActivityContent>
            <Text variant="LabelSmall">
              {`Rp ${string2money(item.price || 0)}`}
            </Text>
          </ActivityContainer>
        ))}
      </>
    </FullContainer>
  );
}
